<template>
  <div>
    <h1>{{ $t("delegationOrder.decision.title") }}</h1>
    <div class="mt-3 elevation-12 grey lighten-4">
      <div class="pa-4">
        <delegation-order-decision-form
          :delegation-decision.sync="delegationDecision"
          @accept="accept"
          @deny="deny"
          @denyAndRevert="denyAndRevert"
          @downloadSettlement="downloadSettlement"
        >
        </delegation-order-decision-form>
      </div>
      <v-card class="grey lighten-4">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="$router.push('/delegation-order')" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import fileDownloadFunction from "../../repository/downloadFile";
import DelegationOrderDecisionForm from "../../components/DelegationOrder/DelegationOrderDecisionForm";

export default {
  name: "DelegationOrderDecisionView",
  components: { DelegationOrderDecisionForm },
  data: () => ({
    delegationDecision: {}
  }),
  created() {
    // if (!(this.$route.params.type === 'financial' || this.$route.params.type === 'substantial')) {
    //     this.$router.push('/delegation');
    // }
    this.downloadDelegationDecision();
  },
  watch: {
    delegationDecision: {
      handler: function(after, before) {
        // Return the object that changed
        // var vm = this;
        // let changed = after.filter(function (p, idx) {
        //     return Object.keys(p).some(function (prop) {
        //         return p[prop] !== vm.$data.oldPeople[idx][prop];
        //     })
        // })
        // // Log it
        // vm.setValue();
        // console.log(after);
        if (typeof before.advances === "object") {
          /* let result = */ this.$store.dispatch("alertDialog", {
            content: this.$t("global.notImplementedYet"),
            title: this.$t("global.error.generalError.title")
          });
        }
        //alert('Funkcjonalność edycji nie została jeszcze zaimplementowana.');
      },
      deep: true
    }
  },
  methods: {
    downloadSettlement() {
      fileDownloadFunction("delegation-order/document-preview?id=" + this.$route.params.id);
    },
    downloadDelegationDecision() {
      this.axios.get("delegation-order/get-decision?delegationId=" + this.$route.params.id).then(resp => {
        this.delegationDecision = resp.data;
      });
    },
    accept() {
      this.axios({
        url: "delegation-order/accept",
        data: { id: this.$route.params.id },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/delegation-order");
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(
          /*err */ () => {
            //TODO obsluga bledow
          }
        );
    },
    deny(promptText) {
      this.axios({
        url: "delegation-order/reject",
        data: {
          id: this.$route.params.id,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/delegation-order");
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    denyAndRevert(promptText) {
      this.axios({
        url: "delegation-order/reject-and-back",
        data: {
          id: this.$route.params.id,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/delegation-order");
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    }
  },
  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped></style>
